<template>
  <div>
    <div class="subnavadmin position-sticky h-screen w-52">
      <!-- <h6 class=" mt-1 pl-4 text-gray-400 font-bold">Menu</h6> -->
      <ul class="">
        <jet-responsive-nav-link
          :href="'/dashboard'"
          class="w-full text-gray-400"
        >
          <i class="dx-icon-home mr-3"></i>
          <!-- <i class="fa fa-home" aria-hidden="true"></i> -->

          <span class="link-label text-sm">Dashboard</span>
        </jet-responsive-nav-link>

        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/users'"
          :href="'/admin/tenant-admin-panels/users'"
          class=""
        >
          <i class="fa fa-user ic" aria-hidden="true"></i>

          <span class="link-label text-sm active">User</span>
        </jet-responsive-nav-link>

        <jet-responsive-nav-link
        :active="currentUrl === '/admin/tenant-admin-panels/roles'"
          :href="'/admin/tenant-admin-panels/roles'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-user-cog ic"></i>
          <span class="link-label text-sm">Roles</span>
        </jet-responsive-nav-link>

        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/products'"
          :href="'/admin/tenant-admin-panels/products'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-box-open ic"></i>
          <span class="link-label text-sm">Products</span>
        </jet-responsive-nav-link>

        <!--  -->
        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/subscriptions'"
          :href="'/admin/tenant-admin-panels/subscriptions'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-id-badge ic"></i>
          <span class="link-label text-sm">Licenses</span>
        </jet-responsive-nav-link>

        <!--  -->
        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/invoices'"
          :href="'/admin/tenant-admin-panels/invoices'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-scroll ic"></i>
          <span class="link-label text-sm">Invoices</span>
        </jet-responsive-nav-link>
        <!--  -->

        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/billingaccounts'"
          :href="'/admin/tenant-admin-panels/billingaccounts'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-file-invoice ic"></i>
          <span class="link-label text-sm">Billing Accounts</span>
        </jet-responsive-nav-link>
        <!--  -->

        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/orgprofile'"
          :href="'/admin/tenant-admin-panels/orgprofile'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-sitemap ic"></i>
          <span class="link-label text-sm">Org Profile</span>
        </jet-responsive-nav-link>

        <!--  -->
        <jet-responsive-nav-link
          v-if="isConsoleRoute"
          :active="route().current('cnsl-branches.index')"
          :href="'/admin/cnsl-branches'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-th mr-3"></i>
          <span class="link-label text">Branch</span>
        </jet-responsive-nav-link>

        <!-- If not, show the other link -->
        <jet-responsive-nav-link
          v-else
          :active="route().current('branches.index')"
          :href="'/admin/branches'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-th mr-3"></i>
          <span class="link-label text">Branch</span>
        </jet-responsive-nav-link>

        <!--  -->

          <!--  -->
        <jet-responsive-nav-link
          v-if="isConsoleRoute"
          :active="route().current('cnsl-tax-units.index')"
          :href="'/admin/cnsl-tax-units'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-chart-pie mr-3"></i>
          <span class="link-label text">Tax Unit</span>
        </jet-responsive-nav-link>

        <!-- If not, show the other link -->
        <jet-responsive-nav-link
          v-else
          :active="route().current('tax-units.index')"
          :href="'/admin/tax-units'"
          class="w-full text-gray-400"
        >
          <i class="fas fa-chart-pie mr-3"></i>
          <span class="link-label text">Tax Unit</span>
        </jet-responsive-nav-link>

        <!--  -->

        <jet-responsive-nav-link href="#" class="w-full text-gray-400">
          <i class="fas fa-headset ic"></i>
          <span class="link-label text">Support</span>
        </jet-responsive-nav-link>

        <!--  -->
        <jet-responsive-nav-link
          :active="currentUrl === '/admin/user-tenant-access-requests'"
          :href="'/admin/user-tenant-access-requests'"
          class="w-full text-gray-400"
        >
          <!-- <i class="fas fa-th mr-3"></i> -->
          <i class="fas fa-user-check ic"></i>
          <span class="link-label text">User Requests</span>
        </jet-responsive-nav-link>

        <jet-responsive-nav-link
          :active="currentUrl === '/admin/tenant-admin-panels/employeeOnboard'"
          :href="'/admin/tenant-admin-panels/employeeOnboard'"
          class="w-full text-gray-400"
        >
          <!-- <i class="fas fa-th mr-3"></i> -->
          <i class="fas fa-user-plus"></i>
          <span class="link-label text">Applicant Requests</span>
        </jet-responsive-nav-link>
      </ul>
    </div>
  </div>
</template>
<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import NavBar from "../Layouts/TallyClinicTopNavbar.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
// import {isElectron,checkTallyIsOpenElectron} from "../modules/UtilsJs/utils.js";
export default {
  components: {
    JetApplicationMark,
    JetDropdown,
    JetDropdownLink,

    NavBar,
    JetResponsiveNavLink,
    DxScrollView,
  },
  data: function () {
    return {
      tally_open_status: "false",
      pullDown: false,
      showScrollbar: "onScroll",
      scrollByContent: true,
      scrollByThumb: true,
      currentUrl: null,
    };
  },
  methods: {
  
    checkTallyStatus() {
      var _this = this;
      checkTallyIsOpenElectron(_this);
    },
    logout() {
      this.$inertia.post(route("logout"));
    },
    reload_in_electron() {
      //check if tally is open
      if (isElectron()) {
        window.api.send("refresh_page");
        window.api.receive("refresh_page-reply", (tally_response) => {});
      }
    },
    
  },
  mounted() {
    this.currentUrl = window.location.pathname;
    console.log("Current Active value", route().current());

    console.log(
      "Active value",
      route().current("tenant-admin-panels.subscriptions", "admin")
    );
    $("li").on("click", function () {
      var a_links = $(this).find("a");
      $("a").removeClass("active");
      a_links.addClass("active");
      var _this = this;
      checkTallyIsOpenElectron(_this);
    });
  },
   computed: {
    isConsoleRoute() {

      console.log("WINDOWS LOCATION URL ",window.location.hostname);
      // Check if the current route starts with 'console'
      return window.location.hostname.startsWith('console');
    },
  }
};
</script>
<style scoped>
.subnavadmin {
  transition: all 0.2s;
  /* margin-top: 35px; */
  /* min-height: 89vh; */
  
  /* margin-left: -48px; */
}

.link-label {
  font-size: 14px;
}
h3 {
  margin-bottom: 0.3rem;
}
.ic {
  width: 35px;
}
.dx-icon-home {
  font: 18px/1 DXIcons;
}
</style>